'use client';

import Container from '@mui/material/Container';
import Typography from '@mui/material/Typography';
import Accordion from '@mui/material/Accordion';
import AccordionSummary from '@mui/material/AccordionSummary';
import AccordionDetails from '@mui/material/AccordionDetails';

import { Iconify } from 'src/components/iconify';

// ----------------------------------------------------------------------

export default function FaqsView() {
    return (
        <Container sx={{ pt: 10, pb: 10 }}>
            <Typography variant="h3" align="center" paragraph>
                Vanliga frågor
            </Typography>

            <Typography align="center" sx={{ color: 'text.secondary', mb: 5 }}>
                Här hittar du svar på de vanligaste frågorna om tjänsten.
            </Typography>

            <Accordion>
                <AccordionSummary expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}>
                    <Typography variant="subtitle1">Hur loggar jag in?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Du loggar in med ditt BankID eller med e-post och lösenord via inloggningssidan.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}>
                    <Typography variant="subtitle1">Hur bokfor jag en händelse?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Gå till "Bokföring" i menyn och välj "Skapa ny". Där kan du ladda upp underlag och fylla i detaljer.
                    </Typography>
                </AccordionDetails>
            </Accordion>

            <Accordion>
                <AccordionSummary expandIcon={<Iconify icon="eva:arrow-ios-downward-fill" />}>
                    <Typography variant="subtitle1">Vad gör jag om något inte fungerar?</Typography>
                </AccordionSummary>
                <AccordionDetails>
                    <Typography>
                        Kontakta vår support eller använd "Rapportera ett problem" länken i menyn.
                    </Typography>
                </AccordionDetails>
            </Accordion>
        </Container>
    );
}
